var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as t from 'io-ts';
import * as tt from 'io-ts-types';
var toUndefined = function (x) { return (x === null ? undefined : x); };
export var OptionFromUndefinedURI = Symbol('OptionFromUndefined');
var OptionFromUndefinedType = /** @class */ (function (_super) {
    __extends(OptionFromUndefinedType, _super);
    function OptionFromUndefinedType(name, is, validate, encode, type) {
        var _this = _super.call(this, name, is, validate, encode) || this;
        _this.type = type;
        _this._tag = OptionFromUndefinedURI;
        return _this;
    }
    return OptionFromUndefinedType;
}(t.Type));
export { OptionFromUndefinedType };
export var optionFromUndefined = function (type) {
    var codec = tt.mapOutput(tt.optionFromNullable(type), toUndefined);
    return new OptionFromUndefinedType("Option<".concat(type.name, ">"), codec.is, codec.validate, codec.encode, type);
};
export var isOptionFromUndefined = function (codec) { return '_tag' in codec && codec._tag === OptionFromUndefinedURI; };
